// extracted by mini-css-extract-plugin
export var cardPartners = "partners-module--cardPartners--9GZsa";
export var contact = "partners-module--contact--rPokq";
export var partners = "partners-module--partners--Sfol7";
export var title = "partners-module--title--y942w";